import { AudioWavePlayer } from "@/component/AudioWavePlayer";
import { ArtifactsViewerData } from "@/hooks/useArtifactsViewerData";
import isEqual from "fast-deep-equal";
import React from "react";
import { Section } from "./Section";

type VoiceoverSectionProps = ArtifactsViewerData["voiceover"];

export const VoiceoverSection = React.memo(
  function VoiceoverSection(props: VoiceoverSectionProps) {
    const { id, data, visible, title } = props;

    if (!visible) {
      return null;
    }

    return (
      <Section id={id} title={title}>
        {data.audios.length > 0 && (
          <div className="flex flex-col gap-6 mb-5">
            {data.audios.map((audio, index) => {
              if (!audio.url) {
                return null;
              }
              return (
                <div key={index}>
                  <AudioWavePlayer
                    audioUrl={audio.url}
                    title={audio.name}
                    description={audio.description}
                    downloadFilename={audio.downloadFilename}
                  />
                </div>
              );
            })}
          </div>
        )}
        <div className="whitespace-pre-wrap text-graphite-800">
          {data.script}
        </div>
      </Section>
    );
  },
  (prevProps, nextProps) => {
    return isEqual(prevProps, nextProps);
  }
);
